import { use } from "react";

import type { AbsoluteViewportRestriction } from "@map/mapiq-map/AbsoluteViewportRestriction";
import { type MapData, MapView } from "@map/mapiq-map-react/src/MapView";

import { resolve2dRenderer, resolve3dRenderer } from "../lazyMapRenderer";
import type { MapLibraryProps } from "../types";

// What the renderer itself pads by default, so the first view of a floor matches the older maps
const DEFAULT_VIEWPORT_RESTRICTION: AbsoluteViewportRestriction = {
  paddingTopPixels: 20,
  paddingRightPixels: 20,
  paddingBottomPixels: 20,
  paddingLeftPixels: 20,
};

type MapiqMapViewProps = MapLibraryProps & { mapData: MapData };

export const MapiqMapView = ({ mapData, ...props }: MapiqMapViewProps) => {
  const resolveMapiqMap = use(mapData.type === "2d" ? resolve2dRenderer() : resolve3dRenderer());

  return (
    <MapView
      mapData={mapData}
      resolveMapiqMap={resolveMapiqMap}
      defaultViewportRestriction={DEFAULT_VIEWPORT_RESTRICTION}
      {...props}
    />
  );
};
